import styled from 'styled-components';

export const ControlsWrap = styled.div`
  opacity: 0;
`;

export const CommentWrap = styled.div`
  margin-right: 10px;
  color: ${({ theme }) => theme.colors.mainDark};
  
  &:hover {
    ${ControlsWrap} {
      opacity: 1;
    }
  }
`;

export const CreatorDataWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Creator = styled.div`
  display: flex;
`;

export const CreatorAvatar = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  box-sizing: border-box;
  border: 2px solid ${({ theme }) => theme.colors.fontTangerine};
`;

export const CreatorData = styled.div`
  margin-left: 6px;
`;

export const CreatorName = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: ${({ theme }) => theme.colors.mainDark};
`;

export const Date = styled.div`
  font-size: 10px;
  line-height: 12px;
  color: ${({ theme }) => theme.colors.secondaryDark};
`;



// WEBPACK FOOTER //
// ./src/components/comments-list/comment/styles.js